export default "__VITE_ASSET__DakMDBPo__"